import React from "react";
import moment from "moment-timezone";

export default function AvailabilityDatePicker({ month, onMonthChange, availableDates, selectedDate, onSelect, loading, disabled = false, timezoneName = "UTC" }) {
  const start = moment.tz(month, timezoneName).startOf("month");
  const offset = start.isoWeekday() - 1;
  return <div className="schedule-date-picker" aria-label="Appointment dates" aria-busy={loading}>
    <div className="schedule-date-picker-header">
      <button type="button" aria-label="Previous month" disabled={disabled || start.isSameOrBefore(moment.tz(timezoneName), "month")}
        onClick={() => onMonthChange(start.clone().subtract(1, "month").format("YYYY-MM-DD"))}>‹</button>
      <strong aria-live="polite">{start.format("MMMM YYYY")}</strong>
      <button type="button" aria-label="Next month" disabled={disabled}
        onClick={() => onMonthChange(start.clone().add(1, "month").format("YYYY-MM-DD"))}>›</button>
    </div>
    <div className="schedule-date-grid">
      {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((name) => <span key={name}>{name}</span>)}
      {Array.from({ length: offset }, (_, index) => <span key={`empty-${index}`} />)}
      {Array.from({ length: start.daysInMonth() }, (_, index) => {
        const date = start.clone().date(index + 1).format("YYYY-MM-DD");
        const available = availableDates.includes(date);
        return <button type="button" key={date} disabled={disabled || loading || !available}
          aria-label={`${moment.utc(date).format("dddd, MMMM D")}${available ? ", appointments available" : ", no available appointments"}`}
          aria-pressed={selectedDate === date} className={available ? "has-availability" : ""} onClick={() => onSelect(date)}>{index + 1}</button>;
      })}
    </div>
    {loading && <p className="schedule-help" role="status">Finding available dates…</p>}
  </div>;
}
